export enum APIConstants {
    REDDIT = "Reddit",
    TELEGRAM = "Telegram",
    TWITTER = "Twitter",
}